import { Card, CardContent, Dialog, DialogContent, Grid } from '@mui/material'
import Input from 'common/components/form/Input'
import { BasicDialogAction, BasicDialogTitle } from 'common/components/modal/DialogComponents'
import { selectUnlinkInstanceIds } from 'gdl/customers/CustomersSlice'
import { selectInstances } from 'supervision/instances/InstancesSlice'
import { isNil } from 'lodash'
import PropTypes from 'prop-types'
import React, { useEffect, useMemo, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import Autocomplete from '../../../common/components/form/Autocomplete'

const CustomerInstanceDialog = ({
    isOpen = false,
    onClose = () => {},
    onValidate = () => {},
    customerInstance,
}) => {
    const instances = useSelector(selectInstances, shallowEqual)
    const unLinkInstanceIds = useSelector(selectUnlinkInstanceIds, shallowEqual)
    const [instance, setInstance] = useState()
    const [instanceType, setInstanceType] = useState()

    useEffect(() => {
        if (!isOpen) return

        setInstance(customerInstance?.instance)
        setInstanceType(customerInstance?.instanceType)
    }, [customerInstance?.instance, customerInstance?.instanceType, isOpen])

    const formattedInstances = useMemo(() => {
        const alreadySelectedInstances = unLinkInstanceIds.filter(id => id !== customerInstance?.instance)
        const filteredInstances = instances.filter(i => !alreadySelectedInstances.includes(i.id))
        return filteredInstances.map(i => ({ id: i.id, label: i.name }))
    }, [customerInstance?.instance, instances, unLinkInstanceIds])

    return (
        <Dialog
            open={isOpen}
            maxWidth={'lg'}
        >
            <BasicDialogTitle onClose={onClose}>
                Instance
            </BasicDialogTitle>
            <DialogContent style={{ overflowX: 'hidden' }}>
                <Card>
                    <CardContent>
                        <Grid container columnSpacing={2} rowSpacing={1} alignItems='center' style={{ paddingTop: '5px' }}>
                            <Grid size={6}>
                                <Autocomplete
                                    label='Instance'
                                    items={formattedInstances}
                                    value={instance}
                                    onChange={setInstance}
                                />
                            </Grid>
                            <Grid size={6}>
                                <Input
                                    label={'Type d\'instance'}
                                    value={instanceType}
                                    onChange={setInstanceType}
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </DialogContent>
            <BasicDialogAction
                buttonLabel={isNil(customerInstance) ? 'Créer' : 'Modifier'}
                onValidate={() => onValidate({ instance, instanceType })}
                isDisabled={!instance || !instanceType}
            />
        </Dialog>
    )
}

CustomerInstanceDialog.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    onValidate: PropTypes.func,
    customerInstance: PropTypes.shape({
        instance: PropTypes.number,
        instanceType: PropTypes.string,
    }),
}

export default CustomerInstanceDialog